import type { LeadFormProps, LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FormRadio } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import { REQUEST_CONSULTANT_CALL_OPTIONS } from "../data";

export interface StepFields extends LeadFormStepFields {
	requestConsultantCall: boolean;
}

export interface Props extends LeadFormProps {
	eligible?: string;
}
export class LeadForm extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>A részletes eredményedet e-mailben fogjuk elküldeni számodra!</>,
		eligible: "jogosult lehetsz",
	};

	protected initValues(): StepFields {
		return {
			...super.initValues(),
			requestConsultantCall: undefined,
		};
	}

	protected renderHeader(): ReactNode {
		const { eligible } = this.props;

		return (
			<Card.Header className="text-white text-center bg-green-rounded">
				<Card.Title className="h2">
					A megadott adatok alapján <span className="text-gold">{eligible}</span> a munkáshitelre
				</Card.Title>
			</Card.Header>
		);
	}

	protected renderFields(): ReactNode {
		return (
			<>
				{super.renderFields()}
				<FormRadio
					name="requestConsultantCall"
					options={REQUEST_CONSULTANT_CALL_OPTIONS}
					variant="button"
					required
					className="text-dark pt-3"
				/>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
